<template>
  <div>
    <h4 v-if="!image" class="mb2 lh-title menu-title-section white">{{ title | preposFix }}</h4>
    <img v-if="image" :src="image" :alt="title" class="img-responsive center pb4">

    <div class="menu-section overflow-hidden">
       <div class="menu-holder menu-accordion menu-no-imgs">
         <slot />
       </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true,
      },

      image: {
        type: String,
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/MenuCategory.vue?362ada33